import { render, staticRenderFns } from "./FormDisplay.vue?vue&type=template&id=ebbd97a4&"
import script from "./FormDisplay.vue?vue&type=script&lang=js&"
export * from "./FormDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports